import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';

import { Actions, Effect } from '@ngrx/effects';
import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFireDatabase } from 'angularfire2/database';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import * as firebase from 'firebase';

import { WalletService } from '../services/wallet.service';

import {
  AppAction,
  AppActions,
  IdolsFetchSuccessAction,
  SettingsFetchSuccessAction,
  TokensFetchSuccessAction,
  UserFetchSuccessAction,
  UsersFetchSuccessAction,
  WalletFetchAction,
  WalletFetchSuccessAction
} from './app.actions';
import { ContractsService } from './app.contract.service';
import { AppUtilities } from './app.utilities';
import { NodeService } from '../services/node.service';
import { HomePaginService } from '../services/home.pagin.service';

@Injectable()
export class AppEffects {
  constructor(
    private actions$: Actions,
    private afAuth: AngularFireAuth,
    public afDatabase: AngularFireDatabase,
    public nodeService: NodeService,
    public utilities: AppUtilities,
    private paginService: HomePaginService,
    private walletService: WalletService,
    private contractsService: ContractsService
  ) {}

  @Effect()
  idolsFetch$: Observable<AppAction> = this.actions$
    .ofType(AppActions.IDOLS_FETCH)
    .switchMap((action: AppAction) =>
      this.utilities.loading().then(() =>
        this.nodeService.getIdols().then((response: any) => {
          this.utilities.loadingDismiss();
          return new IdolsFetchSuccessAction(response);
        })
      )
    );

  @Effect()
  settingsFetch$: Observable<AppAction> = this.actions$
    .ofType(AppActions.SETTINGS_FETCH)
    .switchMap((action: AppAction) =>
      this.afDatabase
        .object(`settings/${action.payload}`)
        .map((response: any) => {
          return new SettingsFetchSuccessAction(response.$value);
        })
    );

  @Effect()
  tokensFetch$: Observable<AppAction> = this.actions$
    .ofType(AppActions.TOKENS_FETCH)
    .switchMap((action: AppAction) => {
      this.utilities.loading();
      return this.paginService
        .getAssetsIdsOwnedBy(this.walletService.getAddress())
        .then((response: any[]) => {
          console.log('Tokens fetch' + response);
          this.utilities.loadingDismiss();
          return new TokensFetchSuccessAction(response);
        });
    });

  @Effect()
  userFetch$: Observable<AppAction> = this.actions$
    .ofType(AppActions.USER_FETCH)
    .mergeMap((action: AppAction) => {
      //this.utilities.loading();
      return this.afAuth.authState.map((response: firebase.User) => {
        var acceptDataProtection = true;
        console.log('Usuario registrado EFECTS', response);
        //this.utilities.loadingDismiss();
        if (!response) return new UserFetchSuccessAction(null);
        // Update users table to ensure user existence
        var urlPhoto = '';
        if (response.providerData[0].providerId == 'facebook.com') {
          urlPhoto =
            'https://graph.facebook.com/' +
            response.providerData[0].uid +
            '/picture';
        } else {
          //urlPhoto = response.photoURL;
          urlPhoto =
            'https://firebasestorage.googleapis.com/v0/b/watafan-33650.appspot.com/o/idols%2Fdefault_image.jpeg?alt=media&token=fe080c33-d681-4cdd-a438-295a02a98f4a';
        }
        this.afDatabase.object(`users/${response.uid}`).update({
          uid: response.uid,
          address: this.walletService.getAddress(),
          displayName: response.displayName,
          photoURL: urlPhoto,
          lastLogin: new Date(),
          acceptDataProtection: acceptDataProtection
        });
        return new UserFetchSuccessAction(response ? response.toJSON() : null);
      });
    });

  @Effect()
  userFetchSuccess$ = this.actions$
    .ofType(AppActions.USER_FETCH_SUCCESS)
    .mergeMap((action: AppAction) => {
      return new Promise((resolve, reject) => {
        if (action.payload) {
          resolve(new WalletFetchAction(action.payload));
        } else {
          reject(new Error('Error fetching wallet'));
        }
      });
    });

  @Effect()
  usersFetch$: Observable<AppAction> = this.actions$
    .ofType(AppActions.USERS_FETCH)
    .mergeMap((action: AppAction) =>
      this.afDatabase.list(`users`).map((response: any) => {
        return new UsersFetchSuccessAction(response);
      })
    );

  @Effect()
  walletFetch$ = this.actions$
    .ofType(AppActions.WALLET_FETCH)
    .mergeMap((action: AppAction) =>
      this.contractsService.fetchSCAddresses().then(() => {
        return this.nodeService
          .getBalanceWatacoins()
          .then(response => {
            this.afDatabase
              .object(`users/${action.payload.uid}`)
              .update({
                address: response.address
              })
              .catch(err => {});
            return new WalletFetchSuccessAction(response);
          })
          .catch(err => {
            console.log(err);
          });
      })
    );
}



// WEBPACK FOOTER //
// ./src/app/app.effects.ts